import { List, Record } from 'immutable';
import { makeUserGrantFromSPIUserGrant } from './UserGrant';
const ASP_AUTH_TYPE = 'ASP';
const TWO_LEGGED_AUTH_TYPE = '2LO';
const THREE_LEGGED_AUTH_TYPE = '3LO';
export const makeAppSpecificAuthType = Record({
  type: ASP_AUTH_TYPE
});
export const makeTwoLeggedAuthType = Record({
  type: TWO_LEGGED_AUTH_TYPE
});
export const makeThreeLeggedAuthType = Record({
  type: THREE_LEGGED_AUTH_TYPE,
  grants: List()
});
export function foldAuthType(authType) {
  return function (asp, twoLegged, threeLegged) {
    switch (authType.type) {
      case ASP_AUTH_TYPE:
        return asp(authType);
      case TWO_LEGGED_AUTH_TYPE:
        return twoLegged(authType);
      case THREE_LEGGED_AUTH_TYPE:
        return threeLegged(authType);
      default:
        authType;
        return undefined;
      // TODO MC-2850 - needs to be a compile time validation
      // to check that all cases are covered
    }
  };
}
export const makeAuthTypeFromSPIAuthType = spiAuthType => {
  switch (spiAuthType.type) {
    case 'ASP':
      return makeAppSpecificAuthType();
    case '2LO':
      return makeTwoLeggedAuthType();
    case '3LO':
      return makeThreeLeggedAuthType({
        grants: List(spiAuthType.grants).map(makeUserGrantFromSPIUserGrant)
      });
    default:
      spiAuthType; // to check that all cases are covered
      return undefined;
  }
};